class ClientProperties {
  apiUrl = process.env.REACT_APP_API_URL;
  appName = "W-POS Cloud";
  appDashboardName = "POS Cloud";
  appNameShort = "WPC";
  companyName = "WLabel P.C.";
}

export const properties = new ClientProperties();
